import React from "react";
import { Link } from "react-router-dom";
import FeaturedCard from "../components/FeaturedCard";
import { EventData } from "../types/firebase"; // You might need to create/import your Event type


interface FeaturedEventsProps {
  alignmentClasses: string;
  featuredEvents: EventData[];
}

const FeaturedEvents: React.FC<FeaturedEventsProps> = ({ alignmentClasses, featuredEvents }) => {
  return (
    <div
      className={
      "pt-16 " +
        alignmentClasses
      }
    >

      <h2 className="col-span-full text-center text-3xl font-bold mb-4 font-noto font-italic">Featured Events</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16 mt-16 p-12 ms:p-0">

      {featuredEvents &&
        featuredEvents.map((event) => (
          <FeaturedCard key={event.id} event={event} />
        ))}
      </div>
    </div>
  );
};

export default FeaturedEvents; 